import { action, observable, set } from "mobx";
import moment from "moment";
import Model from "~/models/Model";

class SubscriptionItem extends Model {
  /**
   * @property {number|null}
   */
  @observable subscriptionItemId = null;

  /**
   * @property {number|null}
   */
  @observable subscriptionId = null;

  /**
   * @property {number|null}
   */
  @observable otherProductId = null;

  /**
   * @property {number}
   */
  @observable quantity = 1;

  /**
   * @property {string|null}
   */
  @observable startedDts = null;

  /**
   * @property {string|null}
   */
  @observable endedDts = null;

  /**
   * Set new data to our model
   * @override
   * @param {object} data
   */
  @action
  setData(data) {
    const { startedDts, endedDts, ...rest } = data;
    set(this, rest);

    this.startedDts = startedDts ? moment.unix(startedDts) : null;
    this.endedDts = endedDts ? moment.unix(endedDts) : null;
  }
}

export default SubscriptionItem;
